import { ComplianceListItem } from '../../apis/settings/settingsComplianceListItem.interfaces';

// Indian compliance titles
const complianceTitles = [
  'CBSE Affiliation Renewal', 'Fire Safety Certificate', 'Building Safety Compliance',
  'Health and Hygiene Standards', 'Teacher Qualification Verification', 'Student Safety Protocol',
  'Library Books Inventory', 'Laboratory Equipment Safety', 'Transport Vehicle Registration',
  'Food Safety License', 'Water Quality Testing', 'Waste Management Compliance',
  'Electrical Safety Inspection', 'Playground Equipment Safety', 'Computer Lab Safety',
  'First Aid Kit Availability', 'Emergency Evacuation Plan', 'Anti-Ragging Compliance',
  'Child Protection Policy', 'Data Privacy Compliance', 'Fee Structure Approval',
  'Curriculum Compliance', 'Examination Rules Compliance', 'Attendance Record Maintenance',
  'Student Records Management', 'Staff Records Management', 'Financial Audit Compliance',
  'Tax Compliance', 'Insurance Renewal', 'Land Documents Verification',
  'Building Plan Approval', 'Environmental Clearance', 'No Objection Certificate',
  'Police Verification', 'Medical Checkup Records', 'Vaccination Records',
  'Mid-Day Meal Compliance', 'RTE Act Compliance', 'Disability Access Compliance',
  'Gender Equality Policy', 'Anti-Discrimination Policy', 'Grievance Redressal Mechanism',
  'Parent Consent Forms', 'Field Trip Permissions', 'Photography Consent',
  'Media Consent Forms', 'Student Code of Conduct', 'Staff Code of Conduct',
  'IT Security Compliance', 'Cybersecurity Policy', 'Data Backup Compliance',
  'Disaster Management Plan', 'Flood Safety Measures', 'Earthquake Safety Measures',
];

const statuses = ['PENDING', 'IN_PROGRESS', 'COMPLETED', 'OVERDUE', 'CANCELLED'];
const riskLevels = ['LOW', 'MEDIUM', 'HIGH', 'CRITICAL'];
const priorities = ['LOW', 'MEDIUM', 'HIGH', 'URGENT'];
const authorities = ['CBSE', 'ICSE', 'State Board', 'Local Authority', 'Fire Department', 'Health Department', 'Transport Department'];
const entityTypes = ['SCHOOL', 'BRANCH', 'DEPARTMENT'];
const roles = ['Principal', 'Vice Principal', 'Administrator', 'Compliance Officer', 'Head of Department'];

// Indian names
const indianNames = [
  'Priya Sharma', 'Rajesh Kumar', 'Anjali Patel', 'Vikram Singh', 'Kavita Reddy',
  'Ramesh Agarwal', 'Meera Iyer', 'Amit Gupta', 'Sunita Joshi', 'Suresh Nair',
  'Neha Rao', 'Karan Desai', 'Radha Shah', 'Anil Verma', 'Shreya Agarwal',
];

function generateComplianceItem(index: number): ComplianceListItem {
  const title = complianceTitles[index % complianceTitles.length];
  const status = statuses[index % statuses.length];
  const riskLevel = riskLevels[index % riskLevels.length];
  const priority = priorities[index % priorities.length];
  const authority = authorities[index % authorities.length];
  const entityType = entityTypes[index % entityTypes.length];
  const ownerName = indianNames[index % indianNames.length];
  const role = roles[index % roles.length];
  
  const dueDate = new Date(2025, (index % 12), (index % 28) + 1);
  const nextDueDate = new Date(dueDate);
  nextDueDate.setMonth(nextDueDate.getMonth() + (index % 12) + 1);
  const lastCompletedAt = status === 'COMPLETED' ? new Date(2024, (index % 12), (index % 28) + 1).toISOString().split('T')[0] : '2025-01-01';
  const createdAt = new Date(2024, (index % 12), (index % 28) + 1).toISOString().split('T')[0];
  const updatedAt = new Date(2024, (index % 12) + 1, (index % 28) + 1).toISOString().split('T')[0];
  
  const daysToDue = Math.floor((dueDate.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));
  const isOverdue = daysToDue < 0 && status !== 'COMPLETED';
  
  const tags = [
    'compliance', 'mandatory', 'regulatory', 'safety', 'health',
    'education', 'legal', 'administrative', 'operational', 'financial',
  ].slice(0, 2 + (index % 3));
  
  return {
    id: String(index + 1),
    title,
    status: status as any,
    riskLevel: riskLevel as any,
    priority: priority as any,
    jurisdiction: 'IN',
    authority,
    relatedEntityName: `Delhi Public School ${index % 5 === 0 ? 'Main Campus' : 'Branch ' + (index % 5)}`,
    relatedEntityType: entityType as any,
    primaryOwnerName: ownerName,
    primaryOwnerRole: role,
    dueDate: dueDate.toISOString().split('T')[0],
    nextDueDate: nextDueDate.toISOString().split('T')[0],
    lastCompletedAt,
    isOverdue,
    daysToDue,
    tags,
    hasChecklist: index % 2 === 0,
    hasDocuments: index % 3 !== 0,
    hasOpenChecklistItems: status === 'IN_PROGRESS' && index % 2 === 0,
    createdAt,
    updatedAt,
  };
}

export const mockComplianceList: ComplianceListItem[] = Array.from({ length: 60 }, (_, i) => generateComplianceItem(i));
